/**
* @file 框架-顶部-中间余额信息
* */
<template>
  <div class="header-center flex">
    <!-- 敏感人员预警 -->
    <div class="sensitiveTips" v-if="menuPreFn(63)">
      <div class="sensitiveTips-num" v-if="sensitiveTipsNum > 0">
        {{ sensitiveTipsNum }}
      </div>
      <el-tooltip class="item" effect="dark" content="敏感人员预警" placement="bottom">
        <i class="el-icon-warning" style="font-size: 2rem" @click="$emit('show-sensitive')"></i>
      </el-tooltip>
    </div>

    <!-- 机构余额 -->
    <el-popover 
      popper-class="popover" 
      placement="bottom" 
      trigger="hover" 
      v-if="mixinUserInfo.platformType !== 3"
      :popper-append-to-body="true" 
      :enterable="false" 
      v-model="orderAmountVisible"
    >
      <div slot="reference" class="info-item">
        <span class="info-label">机构余额</span>
        <span class="info-value">¥{{ formatMoney(smsCount.balance) }}</span>
      </div>

      <div class="popover-content">
        <img class="popover-content-bg" src="@/assets/img/head-bg.png" alt="">
        <div class="popover-content-title flex">
          <img src="@/assets/img/head-money.png" alt="">
          <span>后台代机构余额</span>
        </div>
        <div class="popover-content-detail flex-between">
          <p class="popover-content-detail-num"><span>{{ formatMoney(smsCount.balance) }}</span>元</p>
          <p class="popover-content-detail-text">总机构充值</p>
        </div>
      </div>
    </el-popover>

    <div class="line" v-if="mixinUserInfo.platformType !== 3"></div>

    <!-- AI识别余额 -->
    <el-popover 
      popper-class="popover" 
      placement="bottom" 
      trigger="hover"
      :popper-append-to-body="true" 
      :enterable="true" 
      v-model="aiBalanceVisible"
    >
      <div 
        slot="reference" 
        class="info-item"
        :class="{ 'clickable': mixinUserInfo.organizationType === 1 }"
        @click="mixinUserInfo.organizationType === 1 ? $router.push('ai') : null"
      >
        <span class="info-label">AI识别</span>
        <span class="info-value">¥{{ formatMoney(aiBalance.balance) }}</span>
      </div>

      <div class="popover-content">
        <img class="popover-content-bg" src="@/assets/img/head-bg.png" alt="">
        <div class="popover-content-title flex">
          <img src="@/assets/img/head-ai.png" alt="">
          <span>AI识别余额</span>
        </div>
        <div class="popover-content-detail flex-between">
          <p class="popover-content-detail-num"><span>{{ formatMoney(aiBalance.balance) }}</span>元</p>
          <div 
            class="popover-content-detail-btn"
            v-if="(mixinUserInfo.organizationType === 1 || (mixinUserInfo.organizationType === 2 && aiBalance.aiSettleConfig === 2))"
            @click="$emit('ai-recharge')"
          >
            充值
          </div>
          <p class="popover-content-detail-text" v-else>总机构充值</p>
        </div>
      </div>
    </el-popover>

    <div class="line"></div>

    <!-- 剩余短信条数 -->
    <el-popover 
      popper-class="popover" 
      placement="bottom" 
      trigger="hover"
      :popper-append-to-body="true" 
      :enterable="true" 
      v-model="smsCountVisible"
    >
      <div 
        slot="reference" 
        class="info-item"
        :class="{ 'clickable': mixinUserInfo.organizationType === 1 }"
        @click="mixinUserInfo.organizationType === 1 ? $router.push('smsTemplate') : null"
      >
        <span class="info-label">短信</span>
        <span class="info-value">{{ smsCount.count || 0 }}条</span>
      </div>

      <div class="popover-content">
        <img class="popover-content-bg" src="@/assets/img/head-bg.png" alt="">
        <div class="popover-content-title flex">
          <img src="@/assets/img/head-sms.png" alt="">
          <span>短信余额</span>
        </div>
        <div class="popover-content-detail flex-between">
          <p class="popover-content-detail-num"><span>{{ smsCount.count || 0 }}</span>条</p>
          <div 
            class="popover-content-detail-btn"
            v-if="mixinUserInfo.organizationType === 1 || (mixinUserInfo.organizationType === 2 && smsCount.smsSettleConfig === 2)"
            @click="$emit('sms-recharge')"
          >
            充值
          </div>
          <p class="popover-content-detail-text" v-else>总机构充值</p>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'HeaderCenter',
  props: {
    sensitiveTipsNum: {
      type: Number,
      default: 0
    },
    smsCount: {
      type: Object,
      default: () => ({})
    },
    aiBalance: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      orderAmountVisible: false,
      aiBalanceVisible: false,
      smsCountVisible: false
    }
  },
  methods: {
    formatMoney(value) {
      if (!value && value !== 0) return '0.00';
      const num = parseFloat(value);
      return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
}
</script>

<style lang="less" scoped>
.header-center {
  flex: 1;
  justify-content: center;
  align-items: center;
  margin-right: 16px;

  .sensitiveTips {
    margin: 0 16px 0 0;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    transition: all 0.2s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }

    i {
      font-size: 18px;
      color: #E6A23C;
    }

    &-num {
      min-width: 16px;
      height: 16px;
      line-height: 16px;
      padding: 0 4px;
      border-radius: 8px;
      text-align: center;
      font-size: 11px;
      color: white;
      background: #F56C6C;
      position: absolute;
      top: -4px;
      right: -4px;
    }
  }

  .line {
    width: 1px;
    height: 16px;
    background: rgba(255, 255, 255, 0.2);
    margin: 0 12px;
  }

  .info-item {
    display: flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 16px;
    cursor: default;
    transition: all 0.2s ease;
    height: 28px;

    &.clickable {
      cursor: pointer;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }

    .info-label {
      font-size: 13px;
      color: rgba(255, 255, 255, 0.7);
      margin-right: 6px;
    }

    .info-value {
      font-size: 14px;
      font-weight: 500;
      color: #fff;
    }
  }
}

</style>
<!--下拉框作用于全局-->
<style lang="less">
@color-primary: #2B77FF;

.popover {
  // 底部弹出时的箭头
  &[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: @color-primary !important;
    &::after {
      border-bottom-color: @color-primary !important;
    }
  }
  // 顶部弹出时的箭头
  &[x-placement^="top"] .popper__arrow {
    border-top-color: @color-primary !important;
    &::after {
      border-top-color: @color-primary !important;
    }
  }
}
</style>
